import { Component, ElementRef, Input, OnInit } from '@angular/core';

export enum ProgressBarRatioLabelPosition {
  None = 'none',
  Bottom = 'bottom',
  Right = 'right',
}


@Component({
  selector: 'prism-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit {

  public ProgressBarRatioLabelPosition = ProgressBarRatioLabelPosition;

  @Input() currentQuantity: number = 25;
  @Input() totalQuantity: number = 75;
  @Input() deltaQuantity: number = 0;
  @Input() backgroundBarColor: string = 'var(--color-2)';
  @Input() progressBarColor: string = 'var(--color-3)';
  @Input() BarColor: string = 'var(--color-3)';
  @Input() barHeight: string = '2.25rem';

  @Input() ratioPosition: ProgressBarRatioLabelPosition = ProgressBarRatioLabelPosition.Bottom;

  public barWidthPercentage: string = '0%';

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {

  }

  ngOnChanges() {
    this.deltaQuantity = this.deltaQuantity || 0;
    const barWidthRatio = (this.currentQuantity + this.deltaQuantity) / this.totalQuantity;
    if(barWidthRatio > 1) {
      this.barWidthPercentage = '100%';
      return;
    }
    if(barWidthRatio < 0) {
      this.barWidthPercentage = '0%';
      return;
    }
    this.barWidthPercentage = barWidthRatio * 100 + '%';
  }


}
